import { useState, useEffect } from 'react';
import { TimelineEvent } from '../Components/Timeline/Timeline';
import { App, APP_EVENTS } from '../types/museum/museum';
import { getActiveEvent } from '../utils/eventUtils';
import { useTransition } from '../contexts/TransitionContext';
import { useMusic } from '../contexts/MusicContext';

export const useMuseumEvents = (app: App | undefined, events: TimelineEvent[]) => {
  const [progress, setProgress] = useState(0);
  const { setIsPageTransitioning, setIsSceneLoaded } = useTransition();

  const [activeEvent, setActiveEvent] = useState<TimelineEvent>({
    year: '', title: '', img: '', content: '', picName: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<TimelineEvent | null>(null);
  const { fadeAndNavigate } = useMusic();

  useEffect(() => {
    if (!app) return;

    setTimeout(() => {
      setIsSceneLoaded(true);
    }, 2000);

    app.appEventsBus.on(APP_EVENTS.ROOM_PROGRESS, (progress: number) => {
      const progressPercentage = (progress * 100).toFixed(3);
      const newProgress = parseFloat(progressPercentage);
      setProgress(newProgress);
      setActiveEvent(getActiveEvent(newProgress, events));
    });

    app.appEventsBus.on(APP_EVENTS.PICTURE_CLICK, (picName: string) => {
      const event = events.find(e => e.picName === picName);
      if (event) {
        setSelectedEvent(event);
        setIsModalOpen(true);
        const url = new URL(window.location.href);
        url.searchParams.set('event', event.title || '');
        window.history.pushState({}, '', url);
      }
    });

    let point = false;
    let timeout = 0;

    app.appEventsBus.on(APP_EVENTS.PICTURE_OVER, (picName: string) => {
      point = true;
      clearTimeout(timeout)
      //@ts-ignore
      timeout = setTimeout(() => (point = false), 20)
    });


    app.appEventsBus.on(APP_EVENTS.PORTAL_OVER, (portalName: string) => {
      point = true;
      clearTimeout(timeout)
      //@ts-ignore
      timeout = setTimeout(() => (point = false), 20)
    });

    document.addEventListener('pointermove', () => {
      if (point) {
        document.body.style.cursor = 'pointer';
      } else {
        document.body.style.cursor = 'auto';
      }
    })

    app.appEventsBus.on(APP_EVENTS.PORTAL_CLICK, (portalName) => {
      setIsSceneLoaded(false);
      setIsPageTransitioning(true);
      if (portalName.toLowerCase() === 'hall') {
        fadeAndNavigate('/?preloader=true');
      } else {
        fadeAndNavigate(`/museum?target=${encodeURIComponent(portalName.toLowerCase())}&preloader=true`);
      }
    });
  }, [app]);

  return {
    progress,
    activeEvent,
    isModalOpen,
    selectedEvent,
    setIsModalOpen,
    setSelectedEvent
  };
};